const FormSubmitError = ({ children }) => {
   return (
      <p className="text-danger text-center text-sm py-2 px-4 border border-red-300 bg-red-100 rounded mb-4">
         {children}
      </p>
   );
};

export { FormSubmitError };
